// TIBECO - CRM Clienți
import React, { useState } from 'react';
import { 
  Users, 
  Search, 
  Filter, 
  Phone, 
  Mail, 
  MapPin, 
  Calendar,
  Building,
  Home,
  Star,
  TrendingUp,
  Eye,
  Edit,
  Plus,
  History,
  DollarSign,
  Package
} from 'lucide-react';
import Card from '../../components/Card';
import Table from '../../components/Table';
import Badge from '../../components/Badge';
import Modal from '../../components/Modal';

const ClientsCRM = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedFilter, setSelectedFilter] = useState('toti');
  const [selectedClient, setSelectedClient] = useState(null);
  const [showClientModal, setShowClientModal] = useState(false);
  const [showAddClientModal, setShowAddClientModal] = useState(false);

  // Baza de date clienți TIBECO
  const clientiTibeco = [
    {
      id: 1,
      nume: 'Popescu Maria',
      tip: 'B2C',
      telefon: '+40 722 123 456',
      email: 'maria.popescu@email.com',
      adresa: 'Str. Florilor 25, Suceava',
      dataInregistrare: '2024-01-15',
      ultimaComanda: '2024-08-20',
      valoareTotala: 18500,
      numarComenzi: 2,
      status: 'Client activ',
      rating: 5,
      note: 'Client fidel, preferă ferestre PVC premium',
      istoric: [
        {
          data: '2024-08-20',
          tip: 'Comandă',
          descriere: '6 ferestre PVC + ușă intrare',
          valoare: 18500,
          status: 'Finalizată'
        },
        {
          data: '2024-01-15',
          tip: 'Comandă',
          descriere: '4 ferestre baie',
          valoare: 7200,
          status: 'Finalizată'
        }
      ]
    },
    {
      id: 2,
      nume: 'SRL Construct Alpha',
      tip: 'B2B',
      telefon: '+40 721 987 654',
      email: 'office@constructalpha.ro',
      adresa: 'Bd. Eroilor 15, Suceava',
      dataInregistrare: '2023-06-10',
      ultimaComanda: '2024-09-01',
      valoareTotala: 156750,
      numarComenzi: 8,
      status: 'Client VIP',
      rating: 5,
      note: 'Dezvoltator imobiliar - proiecte mari, plăți la timp',
      istoric: [
        {
          data: '2024-09-01',
          tip: 'Ofertă',
          descriere: '24 ferestre bloc + uși balcon',
          valoare: 45200,
          status: 'În așteptare'
        },
        {
          data: '2024-06-15',
          tip: 'Comandă',
          descriere: '36 ferestre rezidențial',
          valoare: 52300,
          status: 'Finalizată'
        },
        {
          data: '2024-03-20',
          tip: 'Comandă',
          descriere: '18 uși intrare bloc',
          valoare: 59250,
          status: 'Finalizată'
        }
      ]
    },
    {
      id: 3,
      nume: 'Georgescu Ion',
      tip: 'B2C',
      telefon: '+40 723 456 789',
      email: 'ion.georgescu@yahoo.com',
      adresa: 'Str. Mihai Viteazu 8, Râșnov',
      dataInregistrare: '2022-11-30',
      ultimaComanda: '2024-08-30',
      valoareTotala: 31400,
      numarComenzi: 3,
      status: 'Client recurent',
      rating: 4,
      note: 'Negociază întotdeauna prețul - client de încredere',
      istoric: [
        {
          data: '2024-08-30',
          tip: 'Negociere',
          descriere: '8 ferestre + ușă garaj',
          valoare: 12800,
          status: 'În negociere'
        },
        {
          data: '2023-09-12',
          tip: 'Comandă',
          descriere: '6 ferestre PVC',
          valoare: 11300,
          status: 'Finalizată'
        },
        {
          data: '2022-12-05',
          tip: 'Comandă',
          descriere: '4 ferestre + ușă',
          valoare: 7300,
          status: 'Finalizată'
        }
      ]
    },
    {
      id: 4,
      nume: 'Hotel Mountain View SRL',
      tip: 'B2B',
      telefon: '+40 724 567 890',
      email: 'contact@mountainview.ro',
      adresa: 'Str. Postavaru 12, Predeal',
      dataInregistrare: '2024-09-01',
      ultimaComanda: null,
      valoareTotala: 0,
      numarComenzi: 0,
      status: 'Lead nou',
      rating: 0,
      note: 'Proiect renovare hotel - potențial mare',
      istoric: [
        {
          data: '2024-09-01',
          tip: 'Prima întâlnire',
          descriere: 'Discuții pentru 36 ferestre + uși terasă',
          valoare: 78300,
          status: 'În evaluare'
        }
      ]
    },
    {
      id: 5,
      nume: 'Marinescu Ana',
      tip: 'B2C',
      telefon: '+40 722 678 901',
      email: 'ana.marinescu@gmail.com',
      adresa: 'Str. Dealul Mare 33, Suceava',
      dataInregistrare: '2024-08-25',
      ultimaComanda: '2024-08-25',
      valoareTotala: 9600,
      numarComenzi: 1,
      status: 'Client nou',
      rating: 5,
      note: 'Foarte mulțumită de servicii - recomandă',
      istoric: [
        {
          data: '2024-08-25',
          tip: 'Comandă',
          descriere: '4 ferestre mansardă',
          valoare: 9600,
          status: 'În producție'
        }
      ]
    },
    {
      id: 6,
      nume: 'Radu Construct SRL',
      tip: 'B2B',
      telefon: '+40 725 789 012',
      email: 'office@raduconstruct.ro',
      adresa: 'Str. Industriei 45, Săcele',
      dataInregistrare: '2023-03-15',
      ultimaComanda: '2024-07-18',
      valoareTotala: 89200,
      numarComenzi: 5,
      status: 'Client VIP',
      rating: 4,
      note: 'Constructor local - colaborare de lungă durată',
      istoric: [
        {
          data: '2024-07-18',
          tip: 'Comandă',
          descriere: '12 uși aluminiu',
          valoare: 28900,
          status: 'Finalizată'
        }
      ]
    }
  ];

  // Statistici clienți
  const statisticiClienti = {
    totalClienti: clientiTibeco.length,
    clientiB2B: clientiTibeco.filter(c => c.tip === 'B2B').length,
    clientiB2C: clientiTibeco.filter(c => c.tip === 'B2C').length,
    valoareMedie: Math.round(clientiTibeco.reduce((sum, c) => sum + c.valoareTotala, 0) / clientiTibeco.length),
    clientiActivi: clientiTibeco.filter(c => c.status === 'Client activ' || c.status === 'Client VIP').length,
    ratingMediu: (clientiTibeco.reduce((sum, c) => sum + c.rating, 0) / clientiTibeco.filter(c => c.rating > 0).length).toFixed(1)
  };

  // Filtrare clienți
  const clientiFiltrati = clientiTibeco.filter(client => {
    const matchesSearch = client.nume.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         client.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         client.telefon.includes(searchTerm);
    
    const matchesFilter = selectedFilter === 'toti' || 
                         (selectedFilter === 'b2b' && client.tip === 'B2B') ||
                         (selectedFilter === 'b2c' && client.tip === 'B2C') ||
                         (selectedFilter === 'activi' && (client.status === 'Client activ' || client.status === 'Client VIP')) ||
                         (selectedFilter === 'noi' && client.status === 'Client nou');
    
    return matchesSearch && matchesFilter;
  });

  const getStatusColor = (status) => {
    const colors = {
      'Client nou': 'blue',
      'Client activ': 'green',
      'Client VIP': 'purple',
      'Client recurent': 'yellow',
      'Lead nou': 'gray'
    };
    return colors[status] || 'gray';
  };

  const getTipIcon = (tip) => {
    return tip === 'B2B' ? <Building className="w-4 h-4" /> : <Home className="w-4 h-4" />;
  };

  const handleClientClick = (client) => {
    setSelectedClient(client);
    setShowClientModal(true);
  };

  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, i) => (
      <Star
        key={i}
        className={`w-4 h-4 ${i < rating ? 'text-yellow-500 fill-current' : 'text-gray-300'}`}
      />
    ));
  };

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        {/* Header */}
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-8">
          <div>
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              CRM Clienți TIBECO
            </h1>
            <p className="text-gray-600 dark:text-gray-400">
              Gestionarea relațiilor cu clienții pentru ferestre și uși
            </p>
          </div>
          
          <button 
            onClick={() => setShowAddClientModal(true)}
            className="flex items-center px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors mt-4 sm:mt-0"
          >
            <Plus className="w-4 h-4 mr-2" />
            Client Nou
          </button>
        </div>

        {/* Statistici */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 mb-8">
          <Card className="p-4">
            <div className="flex items-center justify-between mb-2">
              <Users className="w-5 h-5 text-primary-600" />
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white">
              {statisticiClienti.totalClienti}
            </div>
            <p className="text-xs text-gray-600 dark:text-gray-400">Total Clienți</p>
          </Card>
          
          <Card className="p-4">
            <div className="flex items-center justify-between mb-2">
              <Building className="w-5 h-5 text-blue-600" />
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white">
              {statisticiClienti.clientiB2B}
            </div>
            <p className="text-xs text-gray-600 dark:text-gray-400">Clienți B2B</p>
          </Card>
          
          <Card className="p-4">
            <div className="flex items-center justify-between mb-2">
              <Home className="w-5 h-5 text-green-600" />
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white">
              {statisticiClienti.clientiB2C}
            </div>
            <p className="text-xs text-gray-600 dark:text-gray-400">Clienți B2C</p>
          </Card>
          
          <Card className="p-4">
            <div className="flex items-center justify-between mb-2">
              <DollarSign className="w-5 h-5 text-yellow-600" />
            </div>
            <div className="text-lg font-bold text-gray-900 dark:text-white">
              {statisticiClienti.valoareMedie.toLocaleString()}
            </div>
            <p className="text-xs text-gray-600 dark:text-gray-400">Val. Medie (RON)</p>
          </Card>
          
          <Card className="p-4">
            <div className="flex items-center justify-between mb-2">
              <TrendingUp className="w-5 h-5 text-purple-600" />
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white">
              {statisticiClienti.clientiActivi}
            </div>
            <p className="text-xs text-gray-600 dark:text-gray-400">Activi/VIP</p>
          </Card>
          
          <Card className="p-4">
            <div className="flex items-center justify-between mb-2">
              <Star className="w-5 h-5 text-yellow-500" />
            </div>
            <div className="text-2xl font-bold text-gray-900 dark:text-white">
              {statisticiClienti.ratingMediu}
            </div>
            <p className="text-xs text-gray-600 dark:text-gray-400">Rating Mediu</p>
          </Card>
        </div>

        {/* Filtre și Căutare */}
        <Card className="p-6 mb-8">
          <div className="flex flex-col sm:flex-row gap-4">
            <div className="flex-1">
              <div className="relative">
                <Search className="w-5 h-5 absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                <input
                  type="text"
                  placeholder="Caută după nume, email sau telefon..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="w-full pl-10 pr-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
                />
              </div>
            </div>
            
            <div className="flex items-center space-x-2">
              <Filter className="w-5 h-5 text-gray-400" />
              <select
                value={selectedFilter}
                onChange={(e) => setSelectedFilter(e.target.value)}
                className="px-4 py-2 border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-primary-500 focus:border-primary-500"
              >
                <option value="toti">Toți clienții</option>
                <option value="b2b">Doar B2B</option>
                <option value="b2c">Doar B2C</option>
                <option value="activi">Clienți activi</option>
                <option value="noi">Clienți noi</option>
              </select>
            </div>
          </div>
        </Card>

        {/* Lista Clienți */}
        <Card className="p-6">
          <div className="flex items-center justify-between mb-6">
            <h2 className="text-xl font-semibold text-gray-900 dark:text-white">
              Lista Clienți
            </h2>
            <Badge variant="primary" className="px-3 py-1">
              {clientiFiltrati.length} clienți găsiți
            </Badge>
          </div>

          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="border-b border-gray-200 dark:border-gray-700">
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Client</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Contact</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Tip</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Status</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Valoare</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Rating</th>
                  <th className="text-left py-3 px-4 font-medium text-gray-600 dark:text-gray-400">Acțiuni</th>
                </tr>
              </thead>
              <tbody>
                {clientiFiltrati.map((client) => (
                  <tr 
                    key={client.id} 
                    className="border-b border-gray-100 dark:border-gray-800 hover:bg-gray-50 dark:hover:bg-gray-800 cursor-pointer"
                    onClick={() => handleClientClick(client)}
                  >
                    <td className="py-4 px-4">
                      <div>
                        <div className="font-semibold text-gray-900 dark:text-white">
                          {client.nume}
                        </div>
                        <div className="text-sm text-gray-600 dark:text-gray-400 flex items-center">
                          <MapPin className="w-3 h-3 mr-1" />
                          {client.adresa.split(',')[1] || client.adresa}
                        </div>
                      </div>
                    </td>
                    <td className="py-4 px-4">
                      <div className="space-y-1">
                        <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                          <Phone className="w-3 h-3 mr-1" />
                          {client.telefon}
                        </div>
                        <div className="flex items-center text-sm text-gray-600 dark:text-gray-400">
                          <Mail className="w-3 h-3 mr-1" />
                          {client.email}
                        </div>
                      </div>
                    </td>
                    <td className="py-4 px-4">
                      <div className="flex items-center">
                        {getTipIcon(client.tip)}
                        <span className="ml-2 text-sm font-medium text-gray-900 dark:text-white">
                          {client.tip}
                        </span>
                      </div>
                    </td>
                    <td className="py-4 px-4">
                      <Badge variant={getStatusColor(client.status)}>
                        {client.status}
                      </Badge>
                    </td>
                    <td className="py-4 px-4">
                      <div>
                        <div className="font-semibold text-gray-900 dark:text-white">
                          {client.valoareTotala.toLocaleString()} RON
                        </div>
                        <div className="text-sm text-gray-600 dark:text-gray-400">
                          {client.numarComenzi} comenzi
                        </div>
                      </div>
                    </td>
                    <td className="py-4 px-4">
                      <div className="flex items-center">
                        {client.rating > 0 ? renderStars(client.rating) : (
                          <span className="text-sm text-gray-400">Fără rating</span>
                        )}
                      </div>
                    </td>
                    <td className="py-4 px-4">
                      <div className="flex items-center space-x-2">
                        <button 
                          onClick={(e) => {
                            e.stopPropagation();
                            handleClientClick(client);
                          }}
                          className="p-1 text-gray-400 hover:text-primary-600 transition-colors"
                        >
                          <Eye className="w-4 h-4" />
                        </button>
                        <button className="p-1 text-gray-400 hover:text-blue-600 transition-colors">
                          <Edit className="w-4 h-4" />
                        </button>
                        <button className="p-1 text-gray-400 hover:text-green-600 transition-colors">
                          <History className="w-4 h-4" />
                        </button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          
          {clientiFiltrati.length === 0 && (
            <div className="text-center py-12">
              <Users className="w-12 h-12 text-gray-400 mx-auto mb-4" />
              <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-2">
                Nu au fost găsiți clienți
              </h3>
              <p className="text-gray-600 dark:text-gray-400">
                Încearcă să modifici criteriile de căutare sau filtrare
              </p>
            </div>
          )}
        </Card>
      </div>

      {/* Modal Detalii Client */}
      <Modal isOpen={showClientModal} onClose={() => setShowClientModal(false)}>
        {selectedClient && (
          <div className="p-6 max-w-4xl max-h-[90vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <div className="flex items-center space-x-3">
                {getTipIcon(selectedClient.tip)}
                <div>
                  <h2 className="text-2xl font-bold text-gray-900 dark:text-white">
                    {selectedClient.nume}
                  </h2>
                  <p className="text-gray-600 dark:text-gray-400">
                    Client din {new Date(selectedClient.dataInregistrare).toLocaleDateString('ro-RO')}
                  </p>
                </div>
              </div>
              <Badge variant={getStatusColor(selectedClient.status)}>
                {selectedClient.status}
              </Badge>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 mb-6">
              {/* Informații Contact */}
              <Card className="p-4">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Contact</h3>
                <div className="space-y-3">
                  <div className="flex items-center space-x-2">
                    <Phone className="w-4 h-4 text-gray-400" />
                    <span className="text-sm text-gray-600 dark:text-gray-400">
                      {selectedClient.telefon}
                    </span>
                  </div>
                  <div className="flex items-center space-x-2">
                    <Mail className="w-4 h-4 text-gray-400" />
                    <span className="text-sm text-gray-600 dark:text-gray-400">
                      {selectedClient.email}
                    </span>
                  </div>
                  <div className="flex items-start space-x-2">
                    <MapPin className="w-4 h-4 text-gray-400 mt-0.5" />
                    <span className="text-sm text-gray-600 dark:text-gray-400">
                      {selectedClient.adresa}
                    </span>
                  </div>
                </div>
              </Card>

              {/* Statistici */}
              <Card className="p-4">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Statistici</h3>
                <div className="space-y-3">
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600 dark:text-gray-400">Valoare totală:</span>
                    <span className="text-sm font-medium text-gray-900 dark:text-white">
                      {selectedClient.valoareTotala.toLocaleString()} RON
                    </span>
                  </div>
                  <div className="flex justify-between">
                    <span className="text-sm text-gray-600 dark:text-gray-400">Număr comenzi:</span>
                    <span className="text-sm font-medium text-gray-900 dark:text-white">
                      {selectedClient.numarComenzi}
                    </span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span className="text-sm text-gray-600 dark:text-gray-400">Rating:</span>
                    <div className="flex items-center">
                      {selectedClient.rating > 0 ? renderStars(selectedClient.rating) : (
                        <span className="text-sm text-gray-400">Fără rating</span>
                      )}
                    </div>
                  </div>
                  {selectedClient.ultimaComanda && (
                    <div className="flex justify-between">
                      <span className="text-sm text-gray-600 dark:text-gray-400">Ultima comandă:</span>
                      <span className="text-sm font-medium text-gray-900 dark:text-white">
                        {new Date(selectedClient.ultimaComanda).toLocaleDateString('ro-RO')}
                      </span>
                    </div>
                  )}
                </div>
              </Card>

              {/* Note */}
              <Card className="p-4">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-3">Note</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  {selectedClient.note}
                </p>
              </Card>
            </div>

            {/* Istoric Comenzi */}
            <Card className="p-4">
              <h3 className="font-semibold text-gray-900 dark:text-white mb-4 flex items-center">
                <History className="w-5 h-5 mr-2" />
                Istoric Comenzi
              </h3>
              
              <div className="space-y-3">
                {selectedClient.istoric.map((item, index) => (
                  <div key={index} className="flex items-center justify-between p-3 bg-gray-50 dark:bg-gray-800 rounded-lg">
                    <div className="flex items-center space-x-3">
                      <div className={`w-3 h-3 rounded-full ${
                        item.status === 'Finalizată' ? 'bg-green-500' :
                        item.status === 'În producție' ? 'bg-blue-500' :
                        item.status === 'În negociere' ? 'bg-yellow-500' :
                        'bg-gray-400'
                      }`} />
                      <div>
                        <div className="font-medium text-gray-900 dark:text-white">
                          {item.descriere}
                        </div>
                        <div className="text-sm text-gray-600 dark:text-gray-400">
                          {new Date(item.data).toLocaleDateString('ro-RO')} • {item.tip}
                        </div>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="font-semibold text-gray-900 dark:text-white">
                        {item.valoare.toLocaleString()} RON
                      </div>
                      <Badge variant={
                        item.status === 'Finalizată' ? 'success' :
                        item.status === 'În producție' ? 'primary' :
                        item.status === 'În negociere' ? 'warning' :
                        'gray'
                      } size="sm">
                        {item.status}
                      </Badge>
                    </div>
                  </div>
                ))}
              </div>
            </Card>

            <div className="flex justify-end space-x-3 mt-6">
              <button className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors">
                Editează Client
              </button>
              <button className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors">
                Comandă Nouă
              </button>
            </div>
          </div>
        )}
      </Modal>

      {/* Modal Adaugă Client */}
      <Modal isOpen={showAddClientModal} onClose={() => setShowAddClientModal(false)}>
        <div className="p-6">
          <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">
            Adaugă Client Nou
          </h2>
          
          {/* Form pentru client nou va fi implementat aici */}
          <div className="text-center py-8">
            <Plus className="w-12 h-12 text-gray-400 mx-auto mb-4" />
            <p className="text-gray-600 dark:text-gray-400">
              Formularul pentru adăugarea de clienți noi va fi implementat în următoarea versiune.
            </p>
          </div>

          <div className="flex justify-end space-x-3">
            <button 
              onClick={() => setShowAddClientModal(false)}
              className="px-4 py-2 text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
            >
              Anulează
            </button>
            <button className="px-4 py-2 bg-primary-600 text-white rounded-lg hover:bg-primary-700 transition-colors">
              Salvează Client
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default ClientsCRM;